module.exports = __webpack_public_path__ + "img/coupon_six.76176956.webp";